import { getConfig } from '@chegg-web-tools/config-plugin';
import { HEADER_DATA_SOURCE } from '../externals';
/**
 * This is to configure the header's GraphQL data source, which is currently me-web-bff
 * Note: You must specify the value of the config inside your application's config folder
 * as '<HEADER_DATA_SOURCE>': '<me-web-bff-endpoint>'
 * for the Header to correctly fetch user data.
 */
// Default value for header GQL server in case host application does not pass it via props and neither defines it in the build time configs

export var defaultGQLServer = 'https://gateway.chegg.com/me-web-bff/graphql';
export var consoleErrorMessage = "headerDataSource was neither found in props nor in build-time configuration, falling back to default production value: ".concat(defaultGQLServer, ". Please configure headerDataSource correctly.");
export var configureHeaderGQLServer = function configureHeaderGQLServer(headerDataSource) {
  if (headerDataSource) return headerDataSource;
  var headerGQLServerFromConfig = getConfig(HEADER_DATA_SOURCE);
  if (headerGQLServerFromConfig) return headerGQLServerFromConfig; // Logging console error in case headerDataSource was neither found in props nor in build-time configs

  console.error(consoleErrorMessage);
  return defaultGQLServer;
};